// extracted by mini-css-extract-plugin
module.exports = {"RedirectContent":"_3yYeJLkfATOkds72DT-Ckv"};